<template>
  <div>
    <h2 class="m-0">
      <span>Guía {{ numero ? '# '+numero : ''}}</span>
      <button
        class="btn btn-sm btn-success float-right"
        title="Crear guías desde xls"
        v-if="actual == 1"
        @click="actual = 2">
        <i class="fa fa-upload"></i>
      </button>
      <button
        class="btn btn-sm btn-danger mr-1 float-right"
        title="Cerrar ventana"
        v-if="actual == 2"
        @click="actual = 1">
        <i class="fa fa-times"></i>
      </button>
    </h2>
    <hr class="mt-1 mb-3">
    <div class="card shadow-sm p-3 mb-5 rounded">
      <div class="card-body">
        <GuiaCrearXls v-if="actual == 2"/>
        <form v-else @submit.prevent="guardar">
          <div class="form-group row mb-1">
            <label for="inputOrden" class="col-sm-2 col-form-label">Orden:</label>
            <div class="col-sm-4">
              <input type="text" class="form-control form-control-sm" id="inputOrden" v-model="form.orden">
            </div>
            <label for="inputRecoleccion" class="col-sm-2 col-form-label">Recolección:</label>
            <div class="col-sm-4">
              <select id="inputRecoleccion" class="form-control form-control-sm" :required="true" v-model="form.guia_recoleccion_id">
                <option value="">----------</option>
                <option v-for="i in catalogo.recoleccion" :key="i.id" :value="i.id">{{ i.observaciones }}</option>
              </select>
            </div>
          </div>
          <p class="bg-light text-info font-weight-bold">
            <i class="fa fa-user fa-fw"></i> Destinatario:
          </p>
          <div class="form-group row mb-1">
            <label for="inputIden" class="col-sm-2 col-form-label">Identificación:</label>
            <div class="col-sm-4">
              <input type="text" id="inputIden" class="form-control form-control-sm" v-model="form.identificacion" placeholder="Numero de NIT">
            </div>
            <div class="col-sm-2">
              <button type="button" class="btn btn-sm btn-secondary mr-1" title="Buscar destinatario" @click="getCliente" :disabled="btnCliente">
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  v-if="btnCliente"
                ></span>
                <i v-else class="fa fa-search"></i>
              </button>
            </div>
            <div class="col-sm-4" v-if="bc == 0">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" name="inlineRadioOptions" id="inlineRadio1" :value-true="1" :value-false="0" v-model="form.ccliente">
                <label class="form-check-label" for="inlineRadio1"> Permitir guardar el destinatario</label>
              </div>
            </div>
          </div>
          <div class="form-group row mb-1">
            <label for="inputNombre" class="col-sm-2 col-form-label">Nombre:</label>
            <div class="col-sm-4">
              <input type="text" id="inputNombre" class="form-control form-control-sm" v-model="form.nombre">
            </div>
            <label for="inputDireccion" class="col-sm-2 col-form-label">Dirección:</label>
            <div class="col-sm-4">
              <input type="text" id="inputDireccion" class="form-control form-control-sm" v-model="form.direccion">
            </div>
          </div>
          <div class="form-group row mb-1">
            <label for="inputTelefono" class="col-sm-2 col-form-label">Teléfono:</label>
            <div class="col-sm-4">
              <input type="text" id="inputTelefono" class="form-control form-control-sm" v-model="form.telefono">
            </div>
            <label for="inputcorreo" class="col-sm-2 col-form-label">Correo:</label>
            <div class="col-sm-4">
              <input type="email" id="inputcorreo" class="form-control form-control-sm" v-model="form.correo">
            </div>
          </div>
          <p class="bg-light text-info font-weight-bold">
            <i class="fa fa-list-alt fa-fw"></i> Otros datos:
          </p>

          <div class="form-group row mb-1">
            <div class="col-sm-4 offset-sm-2">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" name="inlineRadioOptions" id="inlineRadio2" :value-true="1" :value-false="0" v-model="form.cod">
                <label class="form-check-label" for="inlineRadio2"> COD</label>
              </div>
            </div>
          </div>

          <div class="form-group row mb-1">
            <label for="inputMonto" class="col-sm-2 col-form-label" v-if="form.cod == 1">COD Monto:</label>
            <div class="col-sm-4" v-if="form.cod == 1">
              <input type="number" id="inputMonto" step="0.01" class="form-control form-control-sm" v-model="form.cod_monto" :required="form.cod == 1">
            </div>

            <label for="inputPeso" class="col-sm-2 col-form-label">Tipo Servicio:</label>
            <div class="col-sm-4">
              <select id="inputPeso" class="form-control form-control-sm" v-model="form.guia_tipo_servicio_id" :required="true">
                  <option v-for="i in catalogo.tipo_servicio" :key="i.id" :value="i.id">{{ i.descripcion }}</option>
              </select>
            </div>
          </div>
          <div class="form-group row mb-1">
            <label for="inputPeso" class="col-sm-2 col-form-label">Peso:</label>
            <div class="col-sm-4">
              <input type="number" id="inputPeso" step="0.01" class="form-control form-control-sm" v-model="form.peso" :required="true">
            </div>
            <label for="inputPeso" class="col-sm-2 col-form-label">Unidad de medida:</label>
            <div class="col-sm-4">
              <select id="inputPeso" class="form-control form-control-sm" v-model="form.unidad_medida_id" :required="true">
                <option value="">---------</option>
                <template v-for="i in catalogo.unidad_medida">
                  <option v-if="i.peso == 1" :key="i.id" :value="i.id">{{ i.nombre }}</option>
                </template>
              </select>
            </div>
          </div>
          <div class="form-group row mb-1">
            <label for="selectDepto" class="col-sm-2 col-form-label">Departamento:</label>
            <div class="col-sm-4">
              <select id="selectDepto" class="form-control form-control-sm" v-model="depto">
                <option value="">--------</option>
                <option v-for="i in catalogo.departamento" :key="i.id" :value="i.id">{{ i.nombre }}</option>
              </select>
            </div>
            <label for="selectMuni" class="col-sm-2 col-form-label">Municipio:</label>
            <div class="col-sm-4">
              <select id="selectMuni" class="form-control form-control-sm" v-model="form.municipio_id" :required="true">
                <option value="">---------</option>
                <option v-for="i in municipios" :key="i.id" :value="i.id">{{ i.nombre }}</option>
              </select>
            </div>
          </div>
          <div class="form-group row mb-2">
            <label for="inputContenido" class="col-sm-2 col-form-label">Contenido:</label>
            <div class="col-sm-4">
              <textarea id="inputContenido" rows="2" class="form-control form-control-sm" v-model="form.contenido"></textarea>
            </div>
            <label for="inputIndicacion" class="col-sm-2 col-form-label">Indicaciones:</label>
            <div class="col-sm-4">
              <textarea id="inputIndicacion" rows="2" class="form-control form-control-sm" v-model="form.indicaciones"></textarea>
            </div>
          </div>
          <div class="form-group row mb-0">
            <div class="col-sm-12 text-right">
              <button type="button" v-if="reg !== ''" class="btn btn-sm btn-secondary mr-1" @click="limpiar">
                Nuevo
              </button>
              <a v-if="reg !== ''" :href="UrlBase+'/hija/get_impresion?guias='+reg" target="_blank" class="btn btn-sm btn-success mr-1">
                <i class="fa fa-print"></i> Imprimir
              </a>
              <button type="submit" class="btn btn-sm btn-primary" :disabled="btnGuardar">
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  v-if="btnGuardar"
                ></span>
                <span class="sr-only" v-if="btnGuardar">
                  {{ reg === '' ? 'Guardando...':'Actualizando...' }}
                </span>
                <span v-if="!btnGuardar">
                  <i class="fa fa-save"></i> 
                  {{ reg === '' ? 'Guardar':'Actualizar' }}
                </span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import GuiaCatalogo from '../mixins/GuiaCatalogo.js';
  import Notificacion from '../mixins/Notificacion.js';
  import GuiaCrearXls from './GuiaCrearXls.vue';

  export default {
    name: 'GuiaCrear',
    mixins: [GuiaCatalogo, Notificacion],
    data: () => {
      return {
        btnCliente: false,
        btnGuardar: false,
        depto: '',
        reg: '',
        bc: 0,
        numero: null,
        actual: 1,
        form: {
          cod: 0,
          unidad_medida_id: '',
          municipio_id: '',
          recoleccion_id: '',
          identificacion: null,
          guia_tipo_servicio_id: ''
        }
      }
    },
    created() {
      this.getCatalogo([
        'unidad_medida',
        'departamento',
        'municipio',
        'recoleccion',
        'tipo_servicio'
        ]);
    },
    methods: {
      guardar() {
        if (confirm('¿Está seguro de guardar la guía?')) {
          this.btnGuardar = true;

          axios
          .post(`${this.UrlBase}/hija/guardar/${this.reg}`, this.form)
          .then(res => {
            if (res.data.exito) {
              this.reg = res.data.reg;
              this.form.ccliente = 0;
              this.numero = res.data.linea.numero;
              this.form.cliente_id = res.data.linea.cliente_id;
              this.showSuccessMsg({message: res.data.mensaje});
            } else {
              this.showErrorMsg({message: res.data.mensaje});
            }
            this.btnGuardar = false;
          }).catch(e => {
            alert('Error Guia '+e);
            this.btnGuardar = false;
          });
        }
      },
      getCliente() {
        if (this.form.identificacion) {
          this.btnCliente = true;
          let datos = {identificacion: this.form.identificacion};

          axios
          .get(`${this.UrlBase}/catalogo/get_cliente`, {params:datos})
          .then(res => {
            if (res.data.existe) {
              this.form.cliente_id = res.data.cliente.id;
              this.form.nombre = res.data.cliente.nombre;
              this.form.correo = res.data.cliente.correo;
              this.form.telefono = res.data.cliente.telefono;
              this.form.direccion = res.data.cliente.direccion;
              this.bc = 1;
            } else {
              this.bc = 0;
              this.form.cliente_id = '';
              this.form.nombre = null;
              this.form.correo = null;
              this.form.telefono = null;
              this.form.direccion = null;
              this.showInfoMsg({message: 'No existe un destinatario con la identificación ingresada, recuerde marcar la opción para guardar el destinatario.'});
            }
            this.btnCliente = false;
          }).catch(e => {
            alert('Cliente '+e);
            this.btnCliente = false;
          });
        } else {
          this.showErrorMsg({message: 'Ingrese la identificación del destinatario'});
        }
      },
      limpiar () {
        this.form = {
          unidad_medida_id: '',
          municipio_id: '',
          identificacion: null
        };

        this.numero = null;
        this.reg = '';
        this.bc  = 0;
      }
    },
    computed: {
      municipios() {
        if (this.depto) {
          return this.catalogo.municipio.filter(o => {
            return o.departamento_id == this.depto
          });
        } else {
          return [];
        }
      }
    },
    components: {
      GuiaCrearXls
    }
  };
</script>